import { render, staticRenderFns } from "./CommentBody.vue?vue&type=template&id=9382b382&scoped=true&"
import script from "./CommentBody.vue?vue&type=script&lang=js&"
export * from "./CommentBody.vue?vue&type=script&lang=js&"
import style0 from "./CommentBody.vue?vue&type=style&index=0&id=9382b382&lang=less&scoped=true&"
import style1 from "./CommentBody.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9382b382",
  null
  
)

export default component.exports